import React, {useState} from 'react';
import {Col, Divider,} from 'antd';
import {accessibilityRoles} from "../../utils/accessUtils";
import AccessControl from "../common/AccessControl";
import ClinicSearchForm from "./ClinicSearchFrom";
import ClinicTreatmentPlanCard from "./cards/ClinicTreatmentPlanCard";
import ClinicProceduresPlanCard from "./cards/ClinicProceduresPlanCard";


const Treatments = () => {
    const toothTab = 0;

    const [keyword, setKeyword] = useState<string>('');

    const [isTreatmentModalVisible, setIsTreatmentModalVisible] = useState(false);
    const [isProcedureModalVisible, setIsProcedureModalVisible] = useState(false);

    const onAddButtonClick = () => {
        if (toothTab === 0) {
            setIsTreatmentModalVisible(true);
        } else if (toothTab === 1) {
            setIsProcedureModalVisible(true);
        }
    };

    const closeModal = () => {
        setIsTreatmentModalVisible(false);
        setIsProcedureModalVisible(false);
    };

    return (

        <AccessControl
            accessibleFor={[accessibilityRoles.CLINIC_ADMIN, accessibilityRoles.MEDICAL_DOCTOR, accessibilityRoles.MEDICAL_ASSISTANT, accessibilityRoles.RECEPTIONIST, accessibilityRoles.DENTAL_TECHNICIAN]}>
            <Col>
                <ClinicSearchForm
                    keyword={keyword}
                    setKeyword={setKeyword}
                    loadData={() => {}}
                    onAddButtonClick={onAddButtonClick}
                />
            </Col>

            <div className="dentobook-content">
                <Divider style={{marginTop: -1}}/>
                {toothTab === 0 ?
                    <ClinicTreatmentPlanCard showModal={isTreatmentModalVisible} onClose={() => closeModal()}
                                             keyword={keyword}/> :
                    <ClinicProceduresPlanCard showModal={isProcedureModalVisible} onClose={() => closeModal()}
                                              keyword={keyword}/>}
            </div>
        </AccessControl>
    );
};
export default Treatments;
